import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import App from '@/app/App'
import { ToastProvider } from '@/components/Toast'
import { initOfflineSync } from '@/lib/offline/syncManager'
import { initPlatformAdapter } from '@/lib/platform'
import './index.css'

initPlatformAdapter()
initOfflineSync()

// 개발 서버의 소스 모듈이 이전 서비스 워커 캐시에 남지 않도록 운영 빌드에서만 등록한다.
if ('serviceWorker' in navigator && window.location.protocol !== 'file:') {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .catch((err) => console.warn('[sw] 등록 실패:', err))
    })
  } else {
    void navigator.serviceWorker.getRegistrations().then((registrations) =>
      Promise.all(registrations.map((registration) => registration.unregister())),
    )
    if ('caches' in window) {
      void caches.keys().then((keys) =>
        Promise.all(
          keys.filter((key) => key.startsWith('seolhwa-bim-')).map((key) => caches.delete(key)),
        ),
      )
    }
  }
}

const queryClient = new QueryClient()

// Electron(file://)에서는 HashRouter, 웹 서버에서는 BrowserRouter
const Router = window.location.protocol === 'file:' ? HashRouter : BrowserRouter

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <Router>
          <App />
        </Router>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
